import * as v from 'valibot';

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const filterFormSchema = v.pipe(
  v.object({
    filterType: v.picklist(['instance', 'pims'], 'Select a filter type'),
    instanceText: v.optional(v.string()),
    selectedPims: v.optional(v.array(v.string())),
  }),
  v.forward(
    v.check(data => {
      if (data.filterType !== 'instance') return true;
      const text = data.instanceText?.trim() ?? '';
      if (!text) return false;
      return text
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
        .every(id => GUID_PATTERN.test(id));
    }, 'Enter valid GUIDs separated by commas'),
    ['instanceText'],
  ),
  v.forward(
    v.check(data => {
      if (data.filterType !== 'pims') return true;
      return (data.selectedPims?.length ?? 0) > 0;
    }, 'Select at least one PIMS'),
    ['selectedPims'],
  ),
);

export type FilterFormValues = v.InferOutput<typeof filterFormSchema>;
